/**
 * OBSERVER-SCOPE-OPTIONS
 * Assouplissements du périmètre observateur, neutralisés par les accès restreints.
 *
 * Quand la gestion par rôles est active, c'est le rôle qui définit seul le
 * périmètre du tableau de bord : les deux options qui l'élargissent ne sont plus
 * prises en compte. Leurs valeurs restent intactes en base — décocher la gestion
 * par rôles les remet en service telles qu'elles étaient.
 */

import { Session } from "@/redux/_session.types"
import { ActionPlanAccess } from "@/redux/account.types"
import { t } from "@/translate/t"

//L'observateur voit toute l'organisation, son périmètre n'est qu'un filtre par défaut
export function observersSeeAllResults(session: Session): boolean {
  return !session.accountOptions.roleManagementEnabled && session.accountOptions.observersSeeAllResults
}

//Les attributs de périmètre s'unionnent au lieu de s'intersecter, et les filtres
//choisis par l'observateur deviennent des sous-filtres
export function isObserverNotRestricted(session: Session): boolean {
  return !session.accountOptions.roleManagementEnabled && session.accountOptions.isObserverNotRestricted
}

//Plans d'action des autres : lecture ou modification sur son périmètre (le serveur vérifie aussi)
export function getActionPlanAccess(session: Session): ActionPlanAccess {
  return session.userRole === "OBSERVER" ? (session.accountOptions.actionPlanAccessForObserver ?? "self") : "self"
}

export function hasActionPlanScope(session: Session): boolean {
  return ["scopeRead", "scopeWrite"].includes(getActionPlanAccess(session))
}

//Pour un observateur limité à son périmètre, « Société » est son périmètre : affiché sous son nom
export function getObserverScopeName(session: Session): string {
  if (session.userRole !== "OBSERVER" || observersSeeAllResults(session)) return ""
  return [session.userFirstname, session.userLastname].filter(Boolean).join(" ")
}

//Libellé du filtre global : le nom de l'observateur limité à son périmètre, sinon le nom du compte
export function getCompanyFilterName(session: Session): string {
  return getObserverScopeName(session) || session.accountName || t("user_company_alt")
}
